<template>
    <div>
        <div class="flex items-start">
        <!-- <feather-icon :icon="notification.icon" :svgClasses="[`text-${notification.category}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon> -->
        <vs-icon icon-pack="material-icons" :icon="notification.icon" :class="[`text-${notification.color}`, 'mr-1']" style="font-size: 36px" />
        <div class="mx-2">
            <span class="font-medium block notification-title" :class="[`text-${notification.color}`]">{{ notification.title }}</span>
            <small>{{ notification.msg }}</small>
        </div>
        </div>
        <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(notification.time) }}</small>
    </div>
</template>

<script>
    import { elapsedTime } from '@/assets/utils/misc.js'

    export default {
        props: {
            notification: Object
        },
        methods: { // TODO: user filter instead
            elapsedTime (time) {
                return elapsedTime(time)
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>